import React from 'react';
import { COLORS, Color } from '../../styles/variables';

interface ChevronDownIconProps {
  size?: number;
  color?: Color;
}

const ChevronDownIcon: React.FC<ChevronDownIconProps> = ({ size = 12, color = COLORS.black }) => (
  <svg width={size} viewBox="0 0 12 6" fill="none">
    <path d="M 0 0 L 6 4 L 12 0" stroke={color} />
  </svg>
);

ChevronDownIcon.defaultProps = {
  size: 12,
  color: COLORS.black,
};

export default ChevronDownIcon;
